import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isMoveDocumentRequestFailure() {
      return getState().isFailure;
    },
    isMoveDocumentRequestPending() {
      return getState().isPending;
    },
    isMoveDocumentRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
